module.exports = __webpack_public_path__ + "static/media/RenaultLifeWeb-Italic.e9c84445.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/renault-life/RenaultLifeWeb-Italic.woff
// module id = 927
// module chunks = 0